module.exports = __webpack_public_path__ + "img/Speaker=Susan Ibach.02eea2dd.png";